export const SET_LEVEL_TO_DISPLAY = 'SET_LEVEL_TO_DISPLAY';

export const setLevelToDisplay = (levelToDisplay: string) => ({
  type: SET_LEVEL_TO_DISPLAY,
  data: levelToDisplay,
});
